<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-2 tw-right-2 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon class="tw-text-white">close</mat-icon>
  </button>

  <div
    mat-dialog-title
    class="matp-bg-warn !tw-flex tw-items-center !tw-pt-2 !tw-text-white"
  >
    <mat-icon class="tw-text-[3rem] !tw-h-12 !tw-w-12 tw-mr-4 matp-fill-icon">
      cancel
    </mat-icon>
    <span class="tw-text-[2rem]">{{ title }}</span>
  </div>

  <mat-dialog-content
    class="!tw-flex tw-flex-col tw-gap-8 tw-w-full tw-whitespace-pre-wrap !tw-text-xl !tw-p-8 !tw-pb-12"
  >
    <span>{{ message }}</span>
    <div class="matp-table-area">
      <table class="matp-table" mat-table [dataSource]="devicesToDelete">
        <!-- シリアル番号列 -->
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef>
            <div class="matp-table-header-title">シリアル番号</div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.serialNo }}</td>
        </ng-container>

        <!-- テナント名列 -->
        <ng-container matColumnDef="tenantName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="matp-table-header-title">テナント名</div>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.tenantName }}</td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="!tw-pb-5">
    <button
      mat-raised-button
      mat-dialog-close
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
    >
      <mat-icon>close</mat-icon>
      キャンセル
    </button>

    <button
      mat-raised-button
      [color]="'warn'"
      class="!tw-min-w-40 tw-my-0 tw-mx-3"
      (click)="doOperation()"
    >
      <mat-icon>done</mat-icon>
      削除
    </button>
  </mat-dialog-actions>
</div>
